export default "__VITE_ASSET__BNb_8Be1__"